// To be used for Common (.NET project) Enums

const enums = {
    accountType: {
        Undefined: 0,
        GIA: 1,
        InvestmentISA: 2,
        CashISA: 3,
        SIPP: 4,
        JISA: 5,
        CashJISA: 6,
        CTF: 7,
        InstantAccessCash: 8
    },
    accountTypeName: {
        GIA: 'General Investment',
        InvestmentISA: 'Investment ISA',
        CashISA: 'Cash ISA',
        SIPP: 'Personal Pension',
        JISA: 'Junior ISA',
        CashJISA: 'Junior Cash ISA',
        CTF: 'Child Trust Fund',
        InstantAccessCash: 'Instant Access Savings Account',
    },
    accountGroup: {
        Investing: 0,
        Saving: 1,
    },
    accountTypeGroup: {},
    accountGroupDescriptor: {},
    portfolioStatus: {
        Created: '0',
        PreInvestment: '1',
        Active: '2',
        Closing: '3',
        Closed: '4',
        Suspended: '5',
        EnrolError: '6',
        EnrolInProgress: '7',
        EnrolQueued: '8',
        Draft: '9',
    },
    breakpoints: {
        mobile: '1rem',
        tablet: '46rem',
        tabletwide: '61rem',
        desktop: '64rem',
        wide: '81rem',
    },
    investmentStyle: {
        Cautious: '1',
        Tentative: '2',
        Confident: '3',
        Ambitious: '4',
        Adventurous: '5'
    },
    pensionCalculatorStatus: {
        Undefined: 0,
        FirstEntered: 1,
        Adjusted: 2,
        Completed: 3,
        Deleted: 4,
        Progress: 5,
    },
    pensionTarget: {
        BaseOnMySalary: 1,
        ChooseTarget: 2,
        DontSet: 3
    },
    projection: {
        Projected: 1,
        Better: 2,
        Worse: 3
    },
    riskValue: {
        One: 1,
        Two: 2,
        Three: 3,
        Four: 4,
        Five: 5
    },
    savingsCalculatorStatus: {
        Undefined: 0,
        FirstEntered: 1,
        Adjusted: 2,
        Completed: 3,
        EngagedWithChoosePlan: 4
    },
    theme: {
        Original: '0',
        Ethical: '1'
    },
    themes: {
        Dark: 'dark',
        Light: 'light',
        FutureSkills: 'future-skills'
    },
    sourceOfWealth: {
        Undefined: 'Undefined',
        Salary: 'Salary',
        Savings: 'Savings',
        Inheritance: 'Inheritance',
        Redundancy: 'Redundancy',
        ExistingPortfolio: 'ExistingPortfolio',
        Spouse: 'Spouse',
        Winnings: 'Winnings',
        Compensation: 'Compensation',
        Divorce: 'Divorce',
        PensionDrawdown: 'PensionDrawdown',
        TrustDistribution: 'TrustDistribution',
        Other: 'Other',
    },
    employmentStatus: {
        Employed: 'Employed',
        SelfEmployed: 'SelfEmployed',
        Retired: 'Retired',
        Unemployed: 'Unemployed',
        FinanciallyIndependent: 'FinanciallyIndependent',
        Student: 'Student',
    },
    transferLogSourceAccountType: {
        CashISA: 0,
        StocksAndSharesISA: 1,
        GIA: 2,
        CashJISA: 3,
        StocksAndSharesJISA: 4,
        CTF: 5,
        SIPP: 6,
        InstantAccessCash: 8
    }
};

enums.accountTypeGroup = {
    GIA: enums.accountGroup.Investing,
    InvestmentISA: enums.accountGroup.Investing,
    CashISA: enums.accountGroup.Saving,
    SIPP: enums.accountGroup.Investing,
    JISA: enums.accountGroup.Investing,
    CashJISA: enums.accountGroup.Saving,
    CTF: enums.accountGroup.Investing,
    InstantAccessCash: enums.accountGroup.Saving,
};

enums.accountGroupDescriptor = {
    [enums.accountGroup.Investing]: 'Plan',
    [enums.accountGroup.Saving]: 'Account',
};

export default Object.freeze(enums);